module.exports = __webpack_public_path__ + "assets/img/8_1688_big.16809de5.jpg";